// extracted by mini-css-extract-plugin
export default {"OTP_container":"OTP_box_OTP_container__64+l8","OTP_div":"OTP_box_OTP_div__Uno51","OTP_form":"OTP_box_OTP_form__nBh++","OTP_btn":"OTP_box_OTP_btn__dS2O9"};